import { useMemo } from "react";
import { ExtraAPIPromiseClient } from "../../../../gen/witbooking/backoffice/extra/v1/extra_api_grpc_web_pb";
import {
  CheckExtraChangeImpactRequest,
  DeleteExtraRequest,
  UpdateExtraRequest,
} from "../../../../gen/witbooking/backoffice/extra/v1/extra_api_pb";
import { useGrpcClient, usePropertyGrpcCall } from "../../../../lib/grpc";
import { ExtraChangeImpactResult } from "../../domain/entities/ExtraChangeImpact";
import { ExtraChangeImpactMapper } from "../mappers/ExtraChangeImpactMapper";

/** Exactly the payload that the following `UpdateExtra` or `DeleteExtra` will receive. */
export type ExtraChange = { update: UpdateExtraRequest } | { delete: DeleteExtraRequest };

export function useExtraImpactApi() {
  const grpcClient = useGrpcClient(ExtraAPIPromiseClient);
  const checkExtraChangeImpact = usePropertyGrpcCall(grpcClient, grpcClient.checkExtraChangeImpact);

  return useMemo(
    () => ({
      checkExtraChangeImpact: async (
        change: ExtraChange,
        locale: string
      ): Promise<ExtraChangeImpactResult> => {
        const request = new CheckExtraChangeImpactRequest();
        if ("update" in change) {
          request.setUpdate(change.update);
        } else {
          request.setDelete(change.delete);
        }
        request.setLocale(locale);
        const response = await checkExtraChangeImpact(request);
        return ExtraChangeImpactMapper.toDomain(response);
      },
    }),
    [checkExtraChangeImpact]
  );
}
